/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlFileMetadataVersionInfo
 */
export interface ControlFileMetadataVersionInfo {
    /**
     * 
     * @type {string}
     * @memberof ControlFileMetadataVersionInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlFileMetadataVersionInfo
     */
    value: string;
}

/**
 * Check if a given object implements the ControlFileMetadataVersionInfo interface.
 */
export function instanceOfControlFileMetadataVersionInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ControlFileMetadataVersionInfoFromJSON(json: any): ControlFileMetadataVersionInfo {
    return ControlFileMetadataVersionInfoFromJSONTyped(json, false);
}

export function ControlFileMetadataVersionInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlFileMetadataVersionInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function ControlFileMetadataVersionInfoToJSON(value?: ControlFileMetadataVersionInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

